module.exports = __webpack_public_path__ + "static/media/img008.6e686e6b.jpg";